import * as Sentry from '@sentry/vue';
import type { OnCreateAppSync } from 'vike-vue/types';
import router from '@/checkout/router-ssr';
import 'iconify-icon';
import { createGtm } from '@gtm-support/vue-gtm';
import gettext from '../gettext';

import Toast, { POSITION } from 'vue-toastification';
import { createPinia } from 'pinia';

export const onCreateApp: OnCreateAppSync = (pageContext): ReturnType<OnCreateAppSync> => {
  if (pageContext.isRenderingHead) {
    return;
  }

  installPinia(pageContext);

  const { app } = pageContext;

  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      trackComponents: true,
    });
  }

  if (import.meta.env.VITE_GTM_ID) {
    const gtm_params = {};
    try {
      Object.assign(gtm_params, JSON.parse(import.meta.env.VITE_GTM_PARAMS));
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      // We don't care if it failed, maybe it wasn't set
    }

    app.use(
      createGtm({
        id: import.meta.env.VITE_GTM_ID,
        queryParams: gtm_params,
      }),
    );
  }

  app.use(gettext).use(router).use(Toast, {
    position: POSITION.TOP_RIGHT,
    timeout: 3000,
    hideProgressBar: true,
    closeButton: false,
    transition: 'Vue-Toastification__fade',
  });
};

type PageContext = Parameters<typeof onCreateApp>[0];
const installPinia = (pageContext: PageContext) => {
  const pinia = createPinia();
  pageContext.app.use(pinia);
  Object.assign(pageContext, { pinia });
};
